import React, { useState } from 'react';
import { globals } from '../../misc/globals';
import BadgeConfig from '../../shared/BadgeConfig';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';
import './BadgingProgressUI.css'
import ContnueButton from './ContinueButton';
var timeout: any = null;

const BadgingProgressUI = (props: UIProperties<BadgingProgressUIConfig>) => {
	const [showProgressSaved, setShowProgressSaved] = useState(true);

	if(showProgressSaved) {
		if(timeout) {
			clearTimeout(timeout);
			timeout = null;
		}
		setTimeout(() => {
			setShowProgressSaved(false);
			timeout = null;
		}, 5000)
	}
	return (
		<div className="in-game-ui-container ui-top-most-container">
			<div className="badging-progress-container center-on-container" id='badging-progress-first' tabIndex={0} aria-label='New Badge Unlocked'>
				<img src="./assets/images/general/backgrounds/badging-background-v1.png"/>
				<div className="badging-progress-desc-container">
					<div className="badging-progress-desc-left">
						<img className="center-on-container" src={props.parameters.unlockedBadge.unlockedImage}/>
					</div>
					<div className="badging-progress-desc-right" style={{
						width: '486px',
						position: 'absolute',
						height: '100%',
						right: '0'
					}}>
						<p tabIndex={0} className="badging-progress-desc big-description-font badge-title">{props.parameters.unlockedBadge.title + ' Complete!'}</p>

						<p tabIndex={0} aria-label={'received ' + props.parameters.unlockedBadge.points + ' out of ' + props.parameters.unlockedBadge.maxPoints + ' Points for this badge'} className="badging-progress-desc big-description-font badge-points">{props.parameters.unlockedBadge.points + '/' + props.parameters.unlockedBadge.maxPoints + ' Points for this badge'}</p>

						<p tabIndex={0} aria-label={props.parameters.allBadges.filter((b: any) => b.isUnlocked).length + ' out of ' + props.parameters.allBadges.length + ' Badges Unlocked'} className="badging-progress-desc big-description-font badge-unlocked">{props.parameters.allBadges.filter((b: any) => b.isUnlocked).length + '/' + props.parameters.allBadges.length + ' Badges Unlocked'}</p>

						<div className="badging-progress-other-badges" aria-label='other badges' style={{
							gridTemplateColumns: (() => {
								var result = '';
								var length = 1;

								if(props.parameters.allBadges.length >= 3) {
									length = 3;
								} else {
									length = props.parameters.allBadges.length;
								}

								for(var indx = 0; indx < length; indx++) {
									result += 'auto ';
								}
								
								return result;
							})(),
							gridTemplateRows: (() => {
								var result = '';
								var length = 1;
								var maxSize = 160;

								if(props.parameters.allBadges.length <= 3) {
									length = 1;
								} else if(props.parameters.allBadges.length <= 6) {
									length = 2;
								} else {
									length = 3;
								}

								for(var indx = 0; indx < length; indx++) {
									result += (maxSize / length) + 'px ';
								}
								
								return result;
							})()
						}}>
							{props.parameters.allBadges.filter((a: any) => a != props.parameters.unlockedBadge).map((b: any, index: number) => {
								return (<img tabIndex={0} aria-label={b.title + '. ' + (b.isUnlocked ? 'unlocked' : 'locked')} key={index} src={b.isUnlocked ? b.unlockedImage : b.lockedImage} alt="" />);
							})}
						</div>
						
						<ContnueButton parameters= {{
							id: 'badging-progress-bottom',
							top: '324px',
							left: '149px',
							width: '190px',
							onClicked: props.parameters.onCloseClicked
						}}/>
					</div>
				</div>
			</div>
			{showProgressSaved ? <p className="regular-description-font" style={{
				color: 'white',
				position: 'absolute',
				margin: '0',
				bottom: '10px',
				right: '10px'
			}}>Progress Saved!</p> : (null)}
			<audio src="./assets/audio/general/Badge_Unlock.mp3" playsInline={true} autoPlay={!globals.isMuted} controls={false}></audio>
		</div>
	);

};

export interface BadgingProgressUIConfig extends BaseConfig{
	unlockedBadge: BadgeConfig;
	allBadges: BadgeConfig[];
	onCloseClicked: () => void;
}

export default BadgingProgressUI;